import React, { useState, useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import TabContainer from "@mui/material/TableContainer";
import ApiUserManager from "../../../core/api/api.userManager";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import ApiClaimManager from "../../../core/api/api.claimManager";
import ApiRoleManager from "../../../core/api/api.roleManager";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import CheckboxTree from "react-checkbox-tree";

const AddEditeModal = ({ showModalEditRole, setShowModalEditRole, selectedRoleId }) => {
  const [tabValue, setTabValue] = React.useState(0);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
  } = useForm({
    defaultValues: { roleList: [], id: "" },
  });
  //const [roleslist, setRolesList] = useState([]);
  const [nodes, setNodes] = React.useState([]);
  const [checked, setChecked] = React.useState([]);
  const [expanded, setExpanded] = React.useState([]);
  //const [extraChecked, setExtraChecked] = useState([]);
  const handleClose = () => {
    setShowModalEditRole(false);
  };
  useEffect(() => {
    (async () => {
      try {
        // // دریافت نقش های موجود برای ادمین
        // const rolesData = await ApiRoleManager.getAllAdminRoles({ pageSize: 100, pageNumber: 1 });
        // setRolesList(rolesData.data);

        // دریافت لیست مجوز ها
        let response = await ApiClaimManager.getTreePermission();
        setNodes([response]);
        setExpanded(["Pages"]);

        if (selectedRoleId != 0) {
          // دریافت اطلاعات کاربر جهت ویرایش
          let response2 = await ApiRoleManager.getRoleById({ id: selectedRoleId });

          setValue("id", response2.data.roleId);
          setValue("name", response2.data.roleName);
          setValue("persianName", response2.data.rolePersianName);

          setChecked(response2.data.roleClaims);
        }
      } catch (error) {
      }
    })();

    return () => { };
  }, []);

  function handleChange(event, newValue) {
    setTabValue(newValue);
  }

  const onSubmit = async (data) => {
    try {
      // بررسی لیست نود های اضافه و در صورت تایید افزودن آن به لیست اصلی
      // let addExtraRoleClaims = [];
      // for (let i = 0; i < extraChecked.length; i++) {
      //     if (_.isEmpty(checked.find(a => a === extraChecked[i])) && !_.isEmpty(checked.find(a => a.includes(extraChecked[i])))) {
      //         // add to checked
      //         checked.push(extraChecked[i]);
      //     }
      // }

      // ساخت لیست مجوزهای انتخابی برای این نقش
      data.roleClaims = checked;

      let response = null;
      if (_.isEmpty(data.id)) response = await ApiRoleManager.createRole(data);
      else response = await ApiRoleManager.updateRole(data);
      handleClose()
      if (response.succeeded == true) document.getElementById("submitButton").click();

      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  const onCheck = (checked, targetNode) => {
    // نود های پدر از لیست اصلی حذف می شوند در صورتی که همه بچه ها کامل انتخاب نشده باشند
    //در صورت نیاز دوباره اضافه شوند
    if (!_.isEmpty(targetNode)) {
      let listParent = targetNode.value.split("."); //.reverse()
      let str = listParent[0];
      for (let i = 0; i < listParent.length - 1; i++) {
        if (_.isEmpty(checked.find((a) => a === str))) {
          // پدر در لیست نیست
          if (!_.isEmpty(checked.find((a) => a === targetNode.value))) {
            //add to list
            checked.push(str);
          } else {
            //remove of list
            if (!_.isEmpty(checked.find((a) => a.indexOf(str) == 0))) {
              checked.push(str);
            }
          }
        }
        str += "." + listParent[i + 1];
      }
    }
    //===== set
    setChecked(checked);
  };

  const onExpand = (expanded) => {
    setExpanded(expanded);
  };

  return (
    <div>
      {/* Start Modal */}
      {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
      <Modal centered size="lg" show={showModalEditRole} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            {selectedRoleId != 0 ? (
              <Modal.Title> ویرایش نقش </Modal.Title>
            ) : (
              <Modal.Title> افزودن نقش جدید</Modal.Title>
            )}
          </Modal.Header>
          <Modal.Body>
            <Paper className="tab-noStyle">
              <Tabs value={tabValue} onChange={handleChange} indicatorColor="primary" textColor="primary">
                <Tab label="اطلاعات نقش" />
                <Tab label="مجوزها" />
              </Tabs>
            </Paper>
            {tabValue === 0 && (
              <TabContainer className=" border border-top-0 py-3 border-bottom-radius">
                <Col xs="12">
                  <Row>
                    <Col xs="12">
                      <Controller
                        name="name"
                        control={control}
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="نام لاتین"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            value={value || ""}
                            onInput={onChange}
                          />
                        )}
                      />
                      {errors.name && <span>لطفا نام لاتین را وارد نمایید</span>}
                    </Col>
                    <Col xs="12">
                      <Controller
                        name="persianName"
                        control={control}
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="نام فارسی"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            value={value || ""}
                            onInput={onChange}
                          />
                        )}
                      />
                      {errors.persianName && <span>لطفا نام فارسی را وارد نمایید</span>}
                    </Col>
                  </Row>
                </Col>
              </TabContainer>
            )}
            {tabValue === 1 && (
              <TabContainer className=" border border-top-0 py-3 border-bottom-radius">
                <Col xs="12">
                  <FormGroup>
                    <CheckboxTree
                      nodes={nodes}
                      checkModel="all"
                      checked={checked}
                      expanded={expanded}
                      iconsClass="fa5"
                      onCheck={onCheck}
                      onExpand={onExpand}
                      icons={{
                        // check: <span className="rct-icon rct-icon-check" />,
                        // uncheck: <span className="rct-icon rct-icon-uncheck" />,
                        // halfCheck: <span className="rct-icon rct-icon-half-check" />,
                        // expandClose: <span className="rct-icon rct-icon-expand-close" />,
                        // expandOpen: <span className="rct-icon rct-icon-expand-open" />,
                        // expandAll: <span className="rct-icon rct-icon-expand-all" />,
                        // collapseAll: <span className="rct-icon rct-icon-collapse-all" />,
                        // parentClose: <span className="rct-icon rct-icon-parent-close" />,
                        // parentOpen: <span className="rct-icon rct-icon-parent-open" />,
                        // leaf: <span className="rct-icon rct-icon-leaf" />,
                        check: <i className="fa fa-check-square text-success" />,
                        uncheck: <i className="fa fa-square" />,
                        halfCheck: <i className="fa fa-check-square text-success" />,
                        expandClose: <i className="fa fa-chevron-left" />,
                        expandOpen: <i className="fa fa-chevron-down" />,
                        expandAll: <i className="fa fa-folder text-warning opacity-50" />,
                        collapseAll: <i className="fa fa-folder-open  text-warning opacity-50" />,
                        parentClose: <i className="fa fa-folder text-warning opacity-50" />,
                        parentOpen: <i className="fa fa-folder-open  text-warning opacity-50" />,
                        leaf: <i className="fa fa-file text-warning opacity-50" />,
                      }}
                    />
                  </FormGroup>
                </Col>
              </TabContainer>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
export default AddEditeModal;
